if (!customElements.get("portraits-section")) {
  customElements.define(
    "portraits-section",
    class PortraitsSection extends HTMLElement {
      constructor() {
        super();

        this.button = null;
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector("[data-portraits-show-more]");

        if (!this.button) {
          return;
        }

        this.button.addEventListener("click", this.handleShowMoreClick);
      }

      disconnectedCallback() {
        if (!this.button) {
          return;
        }

        this.button.removeEventListener("click", this.handleShowMoreClick);
        this.button = null;
      }

      handleShowMoreClick() {
        const isExpanded = this.dataset.portraitsExpanded === "true";
        const nextExpanded = !isExpanded;
        const showMoreLabel = this.button.dataset.showMoreLabel || "Show more";
        const showLessLabel = this.button.dataset.showLessLabel || "Show less";

        this.dataset.portraitsExpanded = String(nextExpanded);
        this.button.textContent = nextExpanded ? showLessLabel : showMoreLabel;
        this.button.setAttribute("aria-expanded", String(nextExpanded));
      }
    },
  );
}
